import React from 'react';

export const ShimmerBlock: React.FC<{ className?: string }> = ({ className = "" }) => (
    <div
        className={`bg-slate-200 animate-shimmer bg-[linear-gradient(90deg,#ececec,#f5f5f5,#ececec)] bg-[length:1000px_100%] rounded ${className}`}
        aria-hidden="true"
    />
);

export const CategoryGridSkeleton: React.FC = () => {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[...Array(6)].map((_, i) => (
                <div key={i} className="p-6 bg-white border border-slate-200 rounded-xl space-y-6">
                    <div className="flex items-start justify-between">
                        <ShimmerBlock className="w-12 h-12 rounded-full" />
                        <ShimmerBlock className="w-8 h-8 rounded-full" />
                    </div>
                    <div className="space-y-3">
                        <ShimmerBlock className="h-5 bg-slate-100 rounded-md w-1/2" />
                        <div className="space-y-2">
                            <ShimmerBlock className="h-3 bg-slate-50 rounded-md w-full" />
                            <ShimmerBlock className="h-3 bg-slate-50 rounded-md w-5/6" />
                        </div>
                    </div>
                    <ShimmerBlock className="h-8 bg-slate-100 rounded-lg w-28" />
                </div>
            ))}
        </div>
    );
};

export const ArticleListSkeleton: React.FC = () => {
    return (
        <div className="space-y-4">
            {[...Array(4)].map((_, i) => (
                <div key={i} className="p-6 bg-white border border-slate-200 rounded-xl space-y-4">
                    <div className="flex items-center gap-2">
                        <ShimmerBlock className="h-4 w-12 rounded" />
                        <ShimmerBlock className="h-4 w-24 rounded" />
                    </div>
                    <ShimmerBlock className="h-6 w-3/4 rounded" />
                    <div className="space-y-2">
                        <ShimmerBlock className="h-3 w-full rounded" />
                        <ShimmerBlock className="h-3 w-5/6 rounded" />
                    </div>
                </div>
            ))}
        </div>
    );
};

export const HelpArticleSkeleton: React.FC = () => {
    return (
        <div className="animate-pulse">
            <ShimmerBlock className="h-4 w-24 mb-12" />
            <ShimmerBlock className="h-12 w-3/4 mb-6" />
            <ShimmerBlock className="h-4 w-48 mb-12" />
            <div className="space-y-6">
                <ShimmerBlock className="h-64 w-full rounded-xl" />
                <div className="space-y-3">
                    <ShimmerBlock className="h-4 w-full" />
                    <ShimmerBlock className="h-4 w-full" />
                    <ShimmerBlock className="h-4 w-5/6" />
                    <ShimmerBlock className="h-4 w-full" />
                    <ShimmerBlock className="h-4 w-4/5" />
                </div>
            </div>
        </div>
    );
};

export const SearchResultSkeleton: React.FC = () => {
    return (
        <div className="p-4 space-y-5">
            {[...Array(3)].map((_, i) => (
                <div key={i} className="space-y-2">
                    <ShimmerBlock className="h-4 w-3/4" />
                    <ShimmerBlock className="h-3 w-full" />
                </div>
            ))}
        </div>
    );
};

export const ArticleTableSkeleton: React.FC<{ rows?: number }> = ({ rows = 5 }) => {
    return (
        <div className="w-full">
            <div className="border-b border-slate-100 p-4 flex justify-between items-center bg-slate-50/50">
                <div className="flex flex-col gap-2">
                    <ShimmerBlock className="h-5 w-32" />
                    <ShimmerBlock className="h-3 w-48" />
                </div>
                <ShimmerBlock className="h-8 w-8 rounded-lg" />
            </div>
            <div className="divide-y divide-slate-100">
                {[...Array(rows)].map((_, i) => (
                    <div key={i} className="p-4 flex items-center justify-between">
                        <div className="flex items-center gap-3 flex-1">
                            <ShimmerBlock className="w-8 h-8 rounded-lg flex-shrink-0" />
                            <div className="space-y-2 flex-1">
                                <ShimmerBlock className="h-4 w-1/3" />
                                <ShimmerBlock className="h-3 w-1/4" />
                            </div>
                        </div>
                        <div className="flex gap-2">
                            <ShimmerBlock className="w-8 h-8 rounded-lg" />
                            <ShimmerBlock className="w-8 h-8 rounded-lg" />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
